<template>
    <div class="profile content-wrapper">
        <div class="title-wrapper">
            <span class="bracket-wrapper">
                <img class="bracket" src="~@/assets/celtic_bracket.png" />
            </span>
            <h1 class="title">
                Profile
            </h1>
            <span class="bracket-wrapper left">
                <img class="bracket flipped" src="~@/assets/celtic_bracket.png" />
            </span>
        </div>
        <div class="content">
            <form class="form" v-on:submit.prevent="onSubmit">
                <div class="form-control-wrapper">
                    <label class="control-label">
                        Username
                    </label>
                    <input
                        class="form-control"
                        v-model="form.username"
                        placeholder="Username"
                        name="username"
                        autocomplete="off"
                    />
                </div>
                <div class="form-control-wrapper">
                    <label class="control-label">
                        Discord
                    </label>
                    <input
                        class="form-control"
                        v-model="form.discord"
                        placeholder="Discord nickname (optional)"
                        name="discord"
                    />
                </div>
                <div class="form-control-wrapper">
                    <label class="control-label">
                        Password
                    </label>
                    <input
                        class="form-control"
                        v-model="form.password"
                        placeholder="Password"
                        name="password"
                        type="password"
                        autocomplete="new-password"
                    />
                    <div class="form-control-remark">
                        Leave this field empty to keep the same password
                    </div>
                </div>
                <div class="form-control-wrapper">
                    <button class="btn btn-primary btn-block">
                        Update
                    </button>
                </div>
            </form>
            <div class="blocked-users" v-if="blockedUsers.length">
                <div class="blocked-users-title">
                    Blocked users
                </div>
                <div class="blocked-users-list">
                    <div
                        class="blocked-user"
                        v-for="(blockedUser, i) in blockedUsers"
                        :key="`blocked-user-${i}`"
                    >
                        <span class="blocked-user-name">
                            {{blockedUser.username}}
                        </span>
                        <button class="btn btn-primary btn-3d unblock-user-btn" @click="unblockUser(blockedUser.uuid)">
                            Unblock
                        </button>
                    </div>
                </div>
            </div>
            <div class="delete-account">
                <button class="btn btn-textual" @click="onDeleteAccount(userId)">
                    Delete Account
                </button>
            </div>
        </div>
        <modal
            :message="deleteAccountModal.message"
            :options="deleteAccountModal.options"
            :show="showDeleteAccountModal"
            type="deleteAccount"
        />
    </div>
</template>

<script>
import api from '../../helpers/api';
import { loginInitialState } from '../Login/Login-state';

export default {
    name: 'Profile',
    created() {
        if (!this.userId) {
            this.$router.push('/');
            return;
        }

        const {
            discord,
            username,
        } = this.$store.state.loginState;

        if (discord) {
            this.form.discord = discord;
        }

        if (username) {
            this.form.username = username;
        }
    },
    async mounted() {
        const response = await api.request('/user/block');
        const blockedUsers = await response.json();

        if (response.ok) {
            this.blockedUsers = blockedUsers;
        }
    },
    data() {
        return {
            form: {
                username: '',
                password: '',
                discord: '',
            },
            blockedUsers: [],
        };
    },
    computed: {
        userId() {
            return this.$store.state.loginState.userId;
        },
        deleteAccountModal() {
            return {
                message: 'Are you sure you want to delete your account?',
                options: [
                    {
                        label: 'Yes',
                        callback: this.onDeleteAccountConfirmation,
                    },
                    {
                        label: 'No',
                        callback: this.onDeleteAccountCancel,
                    },
                ],
            };
        },
        showDeleteAccountModal() {
            return this.$store.state.modalState.modals.deleteAccount.show;
        },
    },
    methods: {
        async onSubmit() {
            const response = await api.request('/user/update', 'POST', this.form);

            if (response.ok) {
                const user = await response.json();
                this.$store.dispatch('setUsername', user.username);
                this.$store.dispatch('setDiscordUsername', user.discord);

                if (user.discord) {
                    this.form.discord = user.discord;
                }

                this.$notify({
                    group: 'app',
                    title: 'Success',
                    type: 'success',
                    text: 'Profile updated successfully!',
                });
                this.form.password = '';
                return;
            }

            const error = await response.json();

            this.$notify({
                group: 'app',
                title: 'Error',
                type: 'error',
                text: error.message,
            });
        },
        onDeleteAccount(userId) {
            this.$store.dispatch('openModal', { type: 'deleteAccount', data: { userId } });
        },
        async onDeleteAccountConfirmation() {
            const response = await api.request('/user/delete', 'POST');

            if (response.ok) {
                this.$store.dispatch('setAuthDetails', loginInitialState);

                this.$notify({
                    group: 'app',
                    title: 'Success',
                    type: 'success',
                    text: 'Account deleted successfully!',
                });

                this.$store.dispatch('closeModal', 'deleteAccount');

                this.$router.push('/');
                return;
            }

            const error = await response.json();

            this.$notify({
                group: 'app',
                title: 'Error',
                type: 'error',
                text: error.message,
            });
        },
        async onDeleteAccountCancel() {
            this.$store.dispatch('closeModal', 'deleteAccount');
        },
        async unblockUser(blockedUserUuid) {
            const response = await api.request(`/user/unblock/${blockedUserUuid}`, 'POST');

            if (response.ok) {
                this.$notify({
                    group: 'app',
                    title: 'Success',
                    type: 'success',
                    text: 'User successfully unblocked',
                });

                this.blockedUsers = this.blockedUsers.filter(blockedUser => blockedUser.uuid !== blockedUserUuid);
            } else {
                this.$notify({
                    group: 'app',
                    title: 'Error',
                    type: 'error',
                    text: 'Error unblocking user',
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .profile {

        i {
            font-style: italic;
        }

        .content {
            margin: 35px auto 0;
            font-size: 1.1em;
        }

        .delete-account {
            text-align: center;

            .btn {
                font-size: .9em;
            }
        }

        .matches {
            margin-top: 20px;
        }

        .blocked-users {
            margin-bottom: 15px;

            .blocked-users-list {
                max-height: 150px;
                overflow: auto;

                 .blocked-user {
                    background: white;
                    border-radius: 4px;
                    display: flex;
                    justify-content: space-between;
                    padding: 6px 8px;

                    > * {
                        align-self: center;
                    }

                    .btn {
                        font-size: .75rem;
                        padding: 3px 6px;
                    }

                    &:not(:first-of-type) {
                        margin-top: 10px;
                    }
                }
            }

            .blocked-users-title {
                font-weight: bold;
                text-align: center;
                margin-bottom: 10px;
            }
        }
    }

    @media only screen and (min-width: $screen-sm) {

        .profile {

            .content {
                max-width: 350px;
            }

            .title-wrapper {

                .title {
                    font-size: 3.5em;
                    max-width: none;
                }
            }
        }
    }

</style>
